import { render, staticRenderFns } from "./pax_form.vue?vue&type=template&id=aa897296&"
import script from "./pax_form.vue?vue&type=script&lang=js&"
export * from "./pax_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports